import deleteAllCookies from './deleteAllCookies.js';
import AWSMobile from '../aws-exports.js';


const signOut = async () => {
  try {
      localStorage.clear();
      deleteAllCookies();
  } catch(error) {
      console.log(error.message);
  }
  window.location.replace(AWSMobile.logout);
};

export default signOut;
